import React, {useContext} from 'react';
import { CalendarContext } from '../context/CalendarProvider';
import Spinner from '../../components/UI/Spinner/Spinner';
import Model from '../../components/UI/Modal/Model';
import IdleTimerContainer from '../../containers/IdleTimer/IdleTimerContainer';
import { AuditProvider } from '../context/AuditProvider';
import AuditOverviewContainer from './AuditOverviewContainer';

function AuditContainer(props) {

    const { idleTimeoutLimit, sessionTimeoutLimit, isLoading, showModel, errorMessage, isError, 
        modelHeaderTitle, resetSubmittedAndErrorFlags } = useContext(CalendarContext);  
 
    return (
        <>
            <div className="sidebar-bottomcontent-container-col">
                <div style={{height:"49.8vh"}}><></></div>    
            </div>
            <div className="sidebar-bottomcontent-container-next-col">
                    <div className="main-contents">
                        <div className="main-content"> 
                            <div className="nmbs-main">
                                <AuditProvider isLogout={props.isLogout}
                                    onLogoutClick={props.onLogoutClick}
                                    clearSessionData={props.clearSessionData}
                                    UserId={props.UserId}
                                    isNmbsUser={props.isNmbsUser}>
                                    <AuditOverviewContainer
                                        isLogout={props.isLogout}
                                        onLogoutClick={props.onLogoutClick}
                                        clearSessionData={props.clearSessionData}
                                        isNmbsUser={props.isNmbsUser}
                                    />
                                </AuditProvider>
                            </div>
                        </div>
                    </div>
            </div> 
            {   
                <Model showModel={showModel}
                    onHideHandler={resetSubmittedAndErrorFlags}
                    showHeader={showModel}
                    headerTitle={modelHeaderTitle}
                    showError={isError}
                    errorMessage={errorMessage}
                />
            }           
            {isLoading ? <Spinner isLogin = {true}/> : undefined}                 
            {sessionTimeoutLimit && idleTimeoutLimit && <IdleTimerContainer idleTimeoutLimit={1000 * idleTimeoutLimit}
                                    sessionTimeoutLimit={1000 * sessionTimeoutLimit}
                                    logout={props.onLogoutClick} />}
        </>
    );
}

export default AuditContainer;